var render, staticRenderFns
import script from "./categoryTabNav.vue?vue&type=script&lang=jsx&"
export * from "./categoryTabNav.vue?vue&type=script&lang=jsx&"
import style0 from "./categoryTabNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports